"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var Money_1 = __importDefault(require("components/Money"));
var DoubleCell_1 = __importDefault(require("containers/TableMaker/components/DoubleCell"));
var VendorsOffer = function (_a) {
    var item = _a.item;
    var discount = item.listPrice && item.vendorQuote && Math.round(((item.listPrice - item.vendorQuote) * 100) / item.listPrice);
    return ((0, jsx_runtime_1.jsx)(DoubleCell_1.default, { main: (0, jsx_runtime_1.jsx)(Money_1.default, { amount: item.vendorQuote, fallbackText: "-", isRounded: true }), 
        // cannot use strong element since the color is overridden by the _material-ui-customize.scss file
        secondary: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Discount ", (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ component: "span", fontWeight: 600 }, { children: [discount || 0, "%"] }))] })), secondaryProps: { color: discount && discount > 0 ? 'green.main' : 'riverstone' } }));
};
exports.default = VendorsOffer;
